<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit PinType</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="dialog = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">What's the name of the PinType?</div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="PinType Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="pr-1">
              <div class="subtitle-2 mb-1">Icon Font Family</div>
              <v-text-field
                v-model="fontFamily"
                hide-details
                dense
                outlined
                placeholder="Icon Font Family"
              ></v-text-field>
            </v-flex>
            <v-flex class="pl-1">
              <div class="subtitle-2 mb-1">Icon Name</div>
              <v-text-field
                v-model="fontName"
                hide-details
                dense
                outlined
                placeholder="Icon Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="pr-1">
              <div class="subtitle-2 mb-1">Background Color</div>
              <v-text-field
                v-model="backgroundColor"
                hide-details
                dense
                outlined
                placeholder="Background Color"
              ></v-text-field>
            </v-flex>
            <v-flex class="pl-1">
              <div class="subtitle-2 mb-1">Icon Color</div>
              <v-text-field
                v-model="fontColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #ffgggs"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex xs6 class="pr-1">
              <div class="subtitle-2 mb-1">Display Priority</div>
              <v-select
                :items="ranks"
                v-model="displayPriority"
                placeholder="Display Priority"
                dense
                outlined
              ></v-select>
            </v-flex>
            <v-flex>
              <div class="subtitle-2 mb-1">State</div>
              <v-select
                :items="['active', 'updated', 'deleted']"
                v-model="state"
                placeholder="State"
                dense
                outlined
              ></v-select>
            </v-flex>
          </v-layout>
          <gallery-image-select-section @imageSelected="galleryImageSelected" />

          <v-img
            v-if="imageUrl && !gallerySelected"
            :src="imageUrl"
            :lazy-src="imageUrl"
            aspect-ratio="1"
            width="100"
          />
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import GalleryImageSelectSection from "@/modules/Assets/components/GalleryImageSelectSection";
export default {
  components: {
    GalleryImageSelectSection,
  },
  props: {
    details: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      dialog: false,
      name: "",
      fontFamily: "",
      fontName: "",
      backgroundColor: "",
      fontColor: "",
      id: "",
      displayPriority: 0,
      state: "",
      imageUrl: "",
      gallerySelected: false,
    };
  },
  computed: {
    ranks() {
      let ranksArray = [];
      for (let i = 1; i < 21; i++) {
        ranksArray.push(i);
      }
      return ranksArray;
    },
    changeFields() {
      return {
        name: this.name,
        fontFamily: this.fontFamily,
        fontName: this.fontName,
        backgroundColor: this.backgroundColor,
        fontColor: this.fontColor,
        displayPriority: this.displayPriority,
        state: this.state,
        id: this.id,
        logo: this.imageUrl,
      };
    },
  },
  //   created() {
  //     console.log(this.pinTypeDetails);
  //   },
  methods: {
    ...mapActions({
      updatePinType: "$_home/updateContent",
      getPinTypes: "$_home/getContent",
    }),
    galleryImageSelected(image) {
      console.log("Image Selected: ", image);
      this.gallerySelected = true;
      this.imageUrl = image.url;
    },
    toggleDialog(details) {
      this.dialog = !this.dialog;
      console.log("opening edit");
      if (this.dialog) {
        console.log(this.details);
        this.gallerySelected = false;
        this.name = details.name;
        this.fontFamily = details.fontFamily;
        this.fontName = details.fontName;
        this.backgroundColor = details.backgroundColor;
        this.fontColor = details.fontColor;
        this.displayPriority = details.displayPriority;
        this.id = details.id;
        this.state = details.state;
        this.imageUrl = details.logo;
      }
    },
    cancel() {
      this.dialog = false;
    },
    save() {
      console.log("Save PinType: ", this.changeFields);
      this.updatePinType({
        details: this.changeFields,
        collection: "pinTypes",
        type: "Pin",
      }).then(() => {
        this.dialog = false;
        this.getPinTypes({
          collection: "pinTypes",
          mutation: "updatePinTypes",
        });
      });
    },
  },
};
</script>

<style></style>
